import React, { useEffect, useState } from 'react';
import styles from './StepButton.module.scss';
import classnames from 'classnames';
import SVG from 'react-inlinesvg';
import check from '../../../assets/icons/check.svg';
/* Interfaces */
import { IStep } from './Steps';

/* Translation */
import { tr } from '../../../utils/translations/translator';
import { useTranslation } from 'react-i18next';

interface StepButtonProps {
  steps: IStep[];
  stepNum: number;
  selected?: boolean;
  onSelect: (opt: number) => void;
  checkStepValidity: (step: number) => boolean;
  selectedStep: IStep;
  tag: IStep;
}

export const StepButton: React.FC<StepButtonProps> = ({
  steps,
  stepNum,
  tag,
  selected = false,
  onSelect,
  checkStepValidity,
  selectedStep,
}) => {
  const cx = classnames.bind(styles);
  const { t } = useTranslation();

  const [showCheck, setShowCheck] = useState(false);
  const [visited, setVisited] = useState(false);

  const isValid = checkStepValidity(stepNum);

  useEffect(() => {
    if (tag === 'DETAIL' || tag === 'PRICE') {
      if (visited || steps.indexOf(selectedStep) >= steps.indexOf(tag)) {
        return setShowCheck(true);
      }
      return setShowCheck(false);
    } else if (isValid) {
      return setShowCheck(true);
    }

    setShowCheck(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStep, isValid]);

  useEffect(() => {
    if (steps.indexOf(selectedStep) >= steps.indexOf(tag)) {
      setVisited(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStep]);

  return (
    <div
      className={
        selected ? cx(styles.StepButton, styles.selected) : styles.StepButton
      }
      onClick={() => onSelect(stepNum)}
    >
      {showCheck ? (
        <span className={styles.completed}>
          <SVG src={check} />
        </span>
      ) : (
        <span
          className={
            selected
              ? cx(styles.stepNumber, styles.selected)
              : styles.stepNumber
          }
        >
          {stepNum + 1}
        </span>
      )}
      <span className={styles.tag}>{tr(t, tag)}</span>
    </div>
  );
};
